import React from "react";
import classNames from "classnames";
export var Stepper = function (_a) {
    var currentStep = _a.currentStep, steps = _a.steps;
    return (React.createElement("section", { className: "stepper" },
        React.createElement("div", { className: "stepper__container" },
            React.createElement("ul", { className: "stepper__items" }, steps.map(function (_a, index) {
                var number = _a.number, name = _a.name;
                return (React.createElement("li", { key: number, className: classNames("stepper__item", {
                        "stepper__item--done": currentStep > index,
                        "stepper__item--active": currentStep === index,
                    }) },
                    index > 0 && React.createElement("div", { className: "stepper__line" }),
                    React.createElement("div", { className: "stepper__content" },
                        React.createElement("span", { className: "stepper__number " }, number),
                        React.createElement("span", { className: "stepper__name" }, name))));
            })))));
};
